import { auth } from '../Firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { getDocs, query, where } from '../leagueStore';
import { usersReference } from '../App';

export async function verifyAdmin() {
  const user = await new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, value => { unsubscribe(); resolve(value); }, reject);
  });
  const email = user?.email;
  if (!email) {
    const error = new Error('Your Google session has expired. Sign in again to check admin access.');
    error.code = 'admin/sign-in-required';
    throw error;
  }
  const users = await getDocs(query(usersReference, where('Email', '==', email)));
  if (!users.docs.some(user => user.data().IsAdmin === true)) {
    throw new Error('These tools are available to league admins.');
  }
}
